<template>
  <div class="loading-spinner">
    <svg
      viewBox="0 0 100 100"
      aria-hidden="true"
      class="loading-spinner__icon"
    >
      <circle
        r="40"
        cx="50"
        cy="50"
        fill="none"
        stroke-width="6"
        class="loading-spinner__track"
      />
      <circle
        r="40"
        cx="50"
        cy="50"
        fill="none"
        stroke-width="6"
        class="loading-spinner__progress-indicator"
        stroke="#e20074"
      />
    </svg>
    <div
      class="sr-only"
      aria-live="polite"
    >
      Lade ...
    </div>
    <div
      v-if="label"
      class="loading-spinner__label"
      aria-hidden="true"
      v-html="label"
    />
  </div>
</template>

<script setup lang="ts">
defineProps({
  label: {
    type: String,
    default: null,
  },
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 60, 252;
    stroke-dashoffset: 60;
  }
  50% {
    stroke-dasharray: 252, 252;
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dasharray: 60, 252;
    stroke-dashoffset: -252;
  }
}

.loading-spinner {
  &__icon {
    height: var(--loading-spinner-width, 3.4rem);
    width: var(--loading-spinner-width, 3.4rem);
    animation: rotate 2s linear infinite;
  }

  &__track {
    stroke: var(--colours-basic-stroke-subtle, #b6b6b6);
  }

  &__progress-indicator {
    stroke: var(--color-primary);
    animation: dash 3.5s ease-in-out infinite;
  }
}
</style>
